var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents2" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c("p", { staticClass: "text1" }, [
        _vm._v("출장정비 (엔진오일, 배터리) "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("1분만에 예약완료")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text2" }, [
        _vm._v("차종선택 → 정비상품선택 → "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("날짜장소선택만 하면 끝!")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-343554d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-343554d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Contents2.vue
// module id = null
// module chunks = 